export default __webpack_public_path__ + "static/media/ascwLogo1.a9fe8267.png";